//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/ScCollector.js";
let d=[[[0,"FindAutomaticRegions",1,0],[0,"KeepRemoveTargetMethod",1,0],[0,"KeepRemoveToolMethod",1,0],[0,"SelectMethod",1,0]],[[[],"AppendOneRegionTracker",{R_:{regionTracker:"GeometricUtilities.RegionTracker"}},0,0],[["regionTracker"],"RemoveOneRegionTracker",{},1,0],[["targets"],"AssignTargets",{},1,0],[["bodySelectionList"],"NotifyBodiesHaveChanged",{},1,0],[[],"ClearRegions",{},0,0],[[],"ClearAllRegionTrackers",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.BooleanRegionSelect = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.BooleanRegionSelect";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.BooleanRegionSelect.SelectOption = Object.freeze({
    "None" : "None", "KeepOrRemove" : "KeepOrRemove", "KeepAndRemove" : "KeepAndRemove"});

SPLM.GeometricUtilities.BooleanRegionSelect.KeepRemoveOption = Object.freeze({
    "Keep" : "Keep", "Remove" : "Remove"});

export default SPLM;